const tooltipContent = `
<h3>Detalle de puntos</h3>
<ul>
    <li>
        <h4>120-170</h4>
        <h5>Registrado</h5>
        <ul>
            <li>- Formación relevante</li>
            <li>- Se mantiene formado/a</li>
        </ul>
    </li>
    <li>
        <h4>270- 390</h4>
        <h5>Confianza</h5>
        <ul>
            <li>- Registrado y Comprometido</li>
            <li>- Amplia experiencia</li>
            <li>- Múltiples referencias de empleadores y clientes</li>
        </ul>
    </li>
    <li>
        <h4>170- 270</h4>
        <h5>Comprometido</h5>
        <ul>
            <li>- Registrado</li>
            <li>- Certificados y Seguros</li>
        </ul>
    </li>
    <li>
        <h4>390- 500</h4>
        <h5>Líder en la industria</h5>
        <ul>
            <li>- Rock Star</li>
            <li>- Influencer en la industria</li>
            <li>- Máster Trainer</li>
        </ul>
    </li>
</ul>
`

export default tooltipContent



// WEBPACK FOOTER //
// ./src/components/TrainerTooltip.js